import imageCompression from 'browser-image-compression'
import { storage } from 'config/firebase'
import { getDownloadURL, ref, uploadBytes } from '@firebase/storage'

export const uploadFileToInventory = async (
  collectionName: string,
  rowId: string,
  file: File,
  compressFile: boolean = false,
) => {
  const unixTime = new Date().getTime()
  const fileName = `${unixTime}_${file.name.replace(/\s/g, '_')}`

  const folderPath = `${collectionName}/${rowId}`
  const storageRef = ref(storage, `${folderPath}/${fileName}`)
  // browser-image-compression only supports images; never run it on video or other blobs.
  const isCompressibleImage =
    file.type.startsWith('image/') && !file.type.toLowerCase().includes('svg') && file.type !== 'image/heic'
  if (compressFile && isCompressibleImage) {
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 3,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    })
    await uploadBytes(storageRef, compressedFile)
  } else {
    await uploadBytes(storageRef, file)
  }
  console.log('storageRef', storageRef)

  const url = await getDownloadURL(storageRef)
  console.log('url', url)
  return { name: file.name, url }
}